import { Box } from "@mui/material";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { ActionTypes } from "../constants/action-types";
import { apiCall } from "../../api/api";
import axios from "axios";

export const registerCarrier = createAsyncThunk(
  ActionTypes.REGISTER_CARRIER,
  async (formData: any, { rejectWithValue }) => {
    try {
      const res = await apiCall("register-carrier/register", "post", formData);
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const loginCarrier = createAsyncThunk(
  ActionTypes.LOGIN_CARRIER,
  async (formData: any, { rejectWithValue }) => {
    try {
      const res = await apiCall("register-carrier/login", "post", formData);
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getBusinessName = createAsyncThunk(
  ActionTypes.BUSINESS_NAME,
  async (email: string, { rejectWithValue }) => {
    try {
      const res = await apiCall(`carrier/business-name/${email}`, "get", email);
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const createCarrier = createAsyncThunk(
  ActionTypes.CREATE_CARRIER,
  async (carrierData: any, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        "carrier/create-or-update",
        "post",
        carrierData
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const sendLogo = createAsyncThunk(
  ActionTypes.SEND_LOGO,
  async (formData: FormData, { rejectWithValue }) => {
    try {
      const jwt = await localStorage.getItem("jwtToken");
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}carrier/upload-logo`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${jwt}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return res.data;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getCarrier = createAsyncThunk(
  ActionTypes.GET_CARRIER,
  async (email: string, { rejectWithValue }) => {
    try {
      const res = await apiCall(`carrier/${email}`, "get", email);
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getCarrierMoves = createAsyncThunk(
  "carrier/getMoves",
  async (carrierId: string, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/move-service/carrier/${carrierId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getCarrierMovesLimited = createAsyncThunk(
  ActionTypes.GET_CARRIER_MOVES_LIMITED,
  async (
    {
      carrierId,
      limit = 5,
      offset = 0,
    }: {
      carrierId: string;
      limit?: number;
      offset?: number;
    },
    { rejectWithValue }
  ) => {
    try {
      const res = await apiCall(
        `move-service/carrier/${carrierId}/limited?limit=${limit}&offset=${offset}`,
        "get",
        carrierId
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const getCarrierMovesByDwelling = createAsyncThunk(
  ActionTypes.GET_CARRIER_MOVES_BY_DWELLING,
  async (
    {
      carrierId,
      dwellingType,
      limit = 5,
      offset = 0,
    }: {
      carrierId: string;
      dwellingType: string;
      limit?: number;
      offset?: number;
    },
    { rejectWithValue }
  ) => {
    try {
      const res = await apiCall(
        `move-service/carrier/${carrierId}/by-dwelling?dwellingType=${dwellingType}&limit=${limit}&offset=${offset}`,
        "get",
        carrierId
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getCarrierMovesCount = createAsyncThunk(
  ActionTypes.GET_CARRIER_MOVES_COUNT,
  async (carrierId: string, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        `move-service/carrier/${carrierId}/count`,
        "get"
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getCarrierMovesCountByDwelling = createAsyncThunk(
  ActionTypes.GET_CARRIER_MOVES_COUNT_BY_DWELLING,
  async (
    { carrierId, dwellingType }: { carrierId: string; dwellingType: string },
    { rejectWithValue }
  ) => {
    try {
      const res = await apiCall(
        `move-service/carrier/${carrierId}/count-by-dwelling?dwellingType=${dwellingType}`,
        "get"
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getAnswer = createAsyncThunk(
  ActionTypes.GET_ANSWER,
  async (
    { email, question }: { email: string; question: string },
    { rejectWithValue }
  ) => {
    try {
      const res = await apiCall(`carrier/answer/${email}`, "post", {
        question,
      });
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const addKnowledge = createAsyncThunk(
  ActionTypes.ADD_KNOWLEDGE,
  async (
    {
      email,
      question,
      answer,
    }: { email: string; question: string; answer: string },
    { rejectWithValue }
  ) => {
    try {
      const res = await apiCall(`carrier/knowledge/`, "post", {
        email,
        question,
        answer,
      });
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const getAllKnowledge = createAsyncThunk(
  ActionTypes.GET_ALL_KNOWLEDGE,
  async (email: string, { rejectWithValue }) => {
    try {
      const res = await apiCall(`carrier/knowledge/${email}`, "get");
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const updateKnowledge = createAsyncThunk(
  ActionTypes.UPDATE_KNOWLEDGE,
  async (
    {
      email,
      question,
      newQuestion,
      newAnswer,
    }: {
      email: string;
      question: string;
      newQuestion: string;
      newAnswer: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const res = await apiCall(`carrier/knowledge`, "patch", {
        email,
        question,
        newQuestion,
        newAnswer,
      });
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const deleteKnowledge = createAsyncThunk(
  ActionTypes.DELETE_KNOWLEDGE,
  async (
    { email, question }: { email: string; question: string },
    { rejectWithValue }
  ) => {
    try {
      const res = await apiCall(`carrier/knowledge/item`, "delete", {
        email,
        question,
      });
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const fetchWebsiteContent = createAsyncThunk(
  ActionTypes.FETCH_WEBSITE_CONTENT,
  async (
    { url, carrierId }: { url: string; carrierId: number },
    { rejectWithValue }
  ) => {
    try {
      const res = await apiCall(`carrier/getWebContent/`, "post", {
        url,
        carrierId,
      });
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getCarrierByBusinessName = createAsyncThunk(
  ActionTypes.GET_CARRIER_BY_BUSINESS_NAME,
  async (BusinessName: string, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        `carrier/carrier/${BusinessName}`,
        "get",
        BusinessName
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const generateCarrierStripeOnboardingSession = createAsyncThunk(
  ActionTypes.GENERATE_CARRIER_STRIPE_ONBOARDING_SESSION,
  async (carrierId: number, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        `register-carrier/stripe-onboarding/${carrierId}`,
        "post",
        undefined
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const createStripeConnectAccount = createAsyncThunk(
  ActionTypes.CREATE_STRIPE_CONNECT_ACCOUNT,
  async (carrierId: number, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        `register-carrier/create-stripe-connect/${carrierId}`,
        "post",
        undefined
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const createCarrierSubscriptionSesison = createAsyncThunk(
  ActionTypes.CREATE_CARRIER_SUBSCRIPTION_SESSION,
  async (body: any, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        `carrier-payment/create-subscription`,
        "post",
        body
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getCarrierSubscriptions = createAsyncThunk(
  ActionTypes.CREATE_CARRIER_SUBSCRIPTION_SESSION,
  async (carrierId: number, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        `carrier-subscriptions/get-subscriptions/${carrierId}`,
        "get"
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const cancelCarrierSubscription = createAsyncThunk(
  ActionTypes.CANCEL_CARRIER_SUBSCRIPTION,
  async (subscriptionId: string, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        `carrier-subscriptions/${subscriptionId}/cancel`,
        "patch"
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const changeActivationStatus = createAsyncThunk(
  ActionTypes.CHANGE_CARRIER_ACTIVATION_STATUS,
  async (carrierId: string, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        `carrier/change-activation-status/${carrierId}`,
        "post"
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
